module.exports = __webpack_public_path__ + "static/media/If I Were King.172974a1.jpg";